import { Component, TemplateRef, ViewChild, EventEmitter, OnInit, Output } from "@angular/core";
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

import { MatDialog } from "@angular/material/dialog";

import { LgdFormControlFactory } from "@tylertech/lgd-reactive-forms";
import { PasswordResetViewModel } from "@tylertech/tyler-api-types";

import { isHttpResponseError, LoggingService, SecurityRoute, UserService } from "../../../services";
import { Router } from "@angular/router";

import { SecurityScreenType } from "../securityScreenType";

export function createNewPasswordValidator(
    passwordControlOrName: string | AbstractControl<unknown>,
    confirmationControlOrName: string | AbstractControl<unknown>): ValidatorFn
{
    return newPasswordValidator;

    function newPasswordValidator(_control: AbstractControl<unknown>): ValidationErrors | null
    {
        const control = typeof passwordControlOrName === "string"
            ? _control.get(passwordControlOrName)
            : passwordControlOrName;
        const confirmationControl = typeof confirmationControlOrName === "string"
            ? _control.get(confirmationControlOrName)
            : confirmationControlOrName;
        if (!control.value || !confirmationControl.value)
        {
            return null;
        }

        if (control.value !== confirmationControl.value)
        {
            return {
                diff: true
            };
        }

        return null;
    }
}

@Component({
    selector: "change-password-form",
    templateUrl: "./changePasswordForm.tmpl.html",
    standalone: false
})
export class ChangePasswordFormComponent
{
    @ViewChild("successMessage") readonly successTemplate: TemplateRef<unknown>;

    @Output() protected readonly goto = new EventEmitter<SecurityScreenType>();

    readonly mainForm: FormGroup;
    error: string;

    constructor(
        private readonly router: Router,
        private readonly matDialog: MatDialog,
        private readonly $loggingService: LoggingService,
        private readonly $userService: UserService,
    )
    {
        this.mainForm = new FormGroup(
            {
                currentPassword: LgdFormControlFactory.text(undefined, true, {}),
                newPassword: LgdFormControlFactory.text(undefined, true, {}),
                newPasswordConfirm: LgdFormControlFactory.text(undefined, true, {}),
            },
            [
                createNewPasswordValidator("newPassword", "newPasswordConfirm")
            ]);
    }

    protected get currentPasswordControl(): AbstractControl<string> { return this.mainForm.get("currentPassword"); }

    protected get newPasswordControl(): AbstractControl<string> { return this.mainForm.get("newPassword"); }

    protected get newPasswordConfirmControl(): AbstractControl<string> { return this.mainForm.get("newPasswordConfirm"); }

    onCancel(): void
    {
        this.goto.emit(SecurityScreenType.Login);
    }

    onSubmit(): Promise<void>
    {
        if (this.mainForm.invalid)
        {
            return Promise.reject();
        }

        const change: PasswordResetViewModel = {
            CurrentPassword: this.currentPasswordControl.value,
            Password: this.newPasswordControl.value,
        };
        return this.$userService.ChangePassword(change)
            .then(
                () =>
                {
                    this.$loggingService.success("password change successful");

                    const dialogRef = this.matDialog.open(this.successTemplate);
                    dialogRef.afterClosed()
                        .subscribe(() =>
                        {
                            this.router.navigate([]);
                        });
                },
                (err: unknown) =>
                {
                    this.error = isHttpResponseError(err)
                        ? err.error.Message
                        : err?.toString();
                    this.$loggingService.info("result:", err);
                });
    }
}
